/* v2 product page (Carmen, 2026-10-14): a piece in several sizes arrives with no size chosen,
   so nobody buys the first size by mistake. The button reads "Select a size" until a size is tapped;
   tapping it, or Shop Pay, before that points to the sizes instead. A ?variant= link keeps its size. */
(() => {
  const root = document.querySelector('product-info.cr-prod');
  if (!root) return;

  // the size chart link sits right after "SIZE" (Carmen, 2026-10-14): CSS places it by the word's width
  const placeChart = () => {
    const legend = root.querySelector('variant-selects legend');
    if (!legend) return;
    const range = document.createRange();
    range.selectNodeContents(legend);
    root.style.setProperty('--cr-size-w', `${Math.ceil(range.getBoundingClientRect().width)}px`);
  };
  placeChart();
  window.addEventListener('resize', placeChart);
  document.fonts?.ready.then(placeChart);

  if (new URLSearchParams(location.search).has('variant')) return;
  const isSize = (f) => /size|talla|taglia/i.test(f.querySelector('legend')?.textContent || '');
  const sizes = [...root.querySelectorAll('variant-selects fieldset')].find(isSize);
  const radios = sizes ? [...sizes.querySelectorAll('input[type="radio"]')] : [];
  if (radios.length < 2 || radios.every((r) => r.classList.contains('disabled'))) return;

  radios.forEach((r) => { r.checked = false; r.removeAttribute('checked'); });
  root.classList.add('cr-nosize');
  const button = root.querySelector('.product-form__submit');
  const label = button?.querySelector('span');
  const text = label?.textContent;
  if (button) button.removeAttribute('disabled');
  if (label) label.textContent = 'Select a size';

  root.querySelector('.product-form__buttons')?.addEventListener('click', (e) => {
    if (!root.classList.contains('cr-nosize')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    root.classList.add('cr-needsize');
    [...root.querySelectorAll('variant-selects fieldset')].find(isSize)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, true);

  root.addEventListener('change', (e) => {
    if (!root.classList.contains('cr-nosize') || !e.target.closest('variant-selects')) return;
    root.classList.remove('cr-nosize', 'cr-needsize');
    if (label && label.isConnected && label.textContent === 'Select a size') label.textContent = text;
  });
})();
